import { useCallback } from 'react';

import { MedicalInformationPractitioner } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useGetCurrentPractitionerGlobalState } from '~libs.shared.account';
import { protectFeature } from '~libs.shared.system';

export const useMedicalInformationRemoveEntryAvailable = (): ((
   practitioner: MedicalInformationPractitioner | undefined,
   medicalInformationRemoved: boolean
) => boolean) => {
   const managingMedicalAttachmentAvailable = protectFeature('managingMedicalAttachment');
   // TODO DREGAB-27482
   const experimental = protectFeature('experimental');
   const { id: currentPractitionerId } = useGetCurrentPractitionerGlobalState();

   return useCallback(
      (practitioner, medicalInformationRemoved: boolean) => {
         const medicalInformationEntryOwner = practitioner?.id.asNumber() === currentPractitionerId;

         return (
            experimental &&
            !medicalInformationRemoved &&
            (managingMedicalAttachmentAvailable || medicalInformationEntryOwner)
         );
      },
      [managingMedicalAttachmentAvailable, currentPractitionerId, experimental]
   );
};
